/* global rwgps */
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import { Routes } from './Routes'
import 'lib/hotnessNotifier'
import { CoreContext } from './CoreContext'
import { DataProvider } from 'data/DataProvider'
import { logErrorBoundActivation } from 'lib/sentry'
import { HelpPopover } from 'features/HelpPopover'
import { ErrorPage } from 'common/ErrorPage'
import { LocaleProvider } from './LocaleProvider'
import { injectIntl } from 'react-intl'

export class CoreApp extends React.PureComponent {
  state = {
    error: null,
    errorInfo: null,
    sentryEventId: null
  }

  componentDidCatch (error, errorInfo) {
    this.setState({ error, errorInfo })
    // see https://sentry.io/ridewithgpscom/rwgps-ui/getting-started/javascript-react/
    // for a full explanation
    logErrorBoundActivation(error, errorInfo)
      .then(sentryEventId => this.setState({ sentryEventId }))
  }

  render () {
    const { error, errorInfo, sentryEventId } = this.state

    return (
      <CoreContext.Provider value>
        <Router>
          {error // we want error page as far up the dom as possible
            ? <ErrorPage error={error} errorInfo={errorInfo} sentryEventId={sentryEventId} />
            : <DataProvider>
              <LocaleProvider>
                <HelpNode />
                <Routes />
              </LocaleProvider>
            </DataProvider>}
        </Router>
      </CoreContext.Provider>
    )
  }
}

const HelpNode = injectIntl(props => {
  const helpNode = document.getElementById('help-show')
  if (helpNode && !rwgps.helpPopover) {
    // we're in core, and the user wants the help button
    const unmountComponent = () => {
      ReactDOM.unmountComponentAtNode(helpNode)
    }
    ReactDOM.render(<LocaleProvider intl={props.intl}><HelpPopover unmountComponent={unmountComponent} {...props} /></LocaleProvider>, helpNode)
  }
  return null
})
